// EtiquetasXL utils - S47.1.
// Helpers puros: conversion mm<->px, snap a grid, clamp, lookup de tamano.
import { LABEL_SIZES, PX_PER_MM, GRID_MM } from './constants';

export function mmToPx(mm) {
  return Number(mm) * PX_PER_MM;
}

export function pxToMm(px) {
  return Number(px) / PX_PER_MM;
}

export function snapMm(mm) {
  const step = GRID_MM;
  const v = Number(mm) || 0;
  return Math.round(v / step) * step;
}

export function clampMm(mm, min, max) {
  const v = Number(mm) || 0;
  if (v < min) return min;
  if (v > max) return max;
  return v;
}

export function findSize(sizeId) {
  for (let i = 0; i < LABEL_SIZES.length; i += 1) {
    if (LABEL_SIZES[i].id === sizeId) return LABEL_SIZES[i];
  }
  return LABEL_SIZES[0];
}

// Genera un id estable y unico para un field nuevo (sin libs).
export function newFieldId() {
  const t = Date.now().toString(36);
  const r = Math.floor(Math.random() * 1e6).toString(36);
  return 'f-' + t + '-' + r;
}
